import { c as _c } from "react/compiler-runtime";
import { initializeApollo } from '@/apollo/apolloClient';
import AppHeader from '@/components/modules/AppHeader';
import ErrorBoundary from '@/components/modules/ErrorBoundary';
import { ActivityBookingProvider } from '@/contexts/activityBookingContext';
import { AppProvider } from '@/contexts/appContext';
import { AvailabilityFiltersProvider } from '@/contexts/availabilityFiltersContext';
import { CartProvider } from '@/contexts/cartContext';
import { I18nProvider } from '@/contexts/i18nContext';
import PageProvider from '@/contexts/pageContext/page.provider';
import StripeProvider from '@/contexts/stripeContext/stripe.provider';
import { TailwindProvider } from '@/contexts/tailwindContext';
import { ApolloProvider } from '@apollo/client';
import { Outlet } from 'react-router-dom';
const client = initializeApollo();
const RootLayout = () => {
    const $ = _c(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = <ErrorBoundary><ApolloProvider client={client}><I18nProvider><AppProvider><PageProvider><TailwindProvider><AvailabilityFiltersProvider><StripeProvider><CartProvider><ActivityBookingProvider><><AppHeader className="pb-2"/><Outlet /></></ActivityBookingProvider></CartProvider></StripeProvider></AvailabilityFiltersProvider></TailwindProvider></PageProvider></AppProvider></I18nProvider></ApolloProvider></ErrorBoundary>;
        $[0] = t0;
    }
    else {
        t0 = $[0];
    }
    return t0;
};
export default RootLayout;
